import { createHashHistory } from 'history';
export default createHashHistory();



// WEBPACK FOOTER //
// ./src/history.js